module.exports = __webpack_public_path__ + "static/media/avg-price-source.4346c575.png";